export default "__VITE_ASSET__CYIqYxSD__"